import { useMemo, useState, type FormEvent } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { referralsService } from '@/services/referralsService'
import { ParceirosBrandShell } from '@/pages/parceiros/ParceirosBrandShell'
import { PARCEIROS_ACCENT, PARCEIROS_PATH, fieldClass, labelClass } from '@/pages/parceiros/parceirosBrand'

export default function PortalIndicacoesAceitar() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const token = useMemo(() => params.get('token') ?? '', [params])
  const [password, setPassword] = useState('')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  async function submit(event: FormEvent) {
    event.preventDefault()
    try {
      await referralsService.acceptInvite(token, password)
      setMessage('Senha definida. Entre com e-mail e senha.')
      navigate(PARCEIROS_PATH)
    } catch {
      setError('Não foi possível ativar o acesso. Peça um novo convite.')
    }
  }

  return (
    <ParceirosBrandShell>
      <div className='mx-auto grid max-w-lg gap-6'>
        <h1 className='text-3xl font-black'>Ativar acesso de parceiro</h1>
        <form onSubmit={submit} className='grid gap-4 rounded-3xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-xl'>
          <label className='grid gap-1.5'>
            <span className={labelClass}>Nova senha</span>
            <span className='text-xs text-white/50'>
              Mínimo de 8 caracteres, com maiúscula, minúscula, número e símbolo.
            </span>
            <input
              className={fieldClass}
              type='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              autoComplete='new-password'
            />
          </label>
          {message && <p className='text-sm text-white/70'>{message}</p>}
          {error && <p className='text-sm text-red-300'>{error}</p>}
          <button
            type='submit'
            disabled={!token}
            className='rounded-full px-5 py-3 text-sm font-medium text-white active:scale-95 disabled:opacity-50'
            style={{ background: PARCEIROS_ACCENT }}
          >
            Definir senha
          </button>
        </form>
      </div>
    </ParceirosBrandShell>
  )
}
